import React from 'react'


const Notification = () => {
  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <h1>Notification</h1>
      </div>
    </div>
  )
}

export default Notification
